/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Card, CardBody} from "reactstrap";

// reactstrap components
import NotificationAlert from "react-notification-alert";


let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
let notificationAlert;
var aTimeout = null;

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
function Aphorisms() {

  let session = JSON.parse(window.sessionStorage.getItem('sessions'));
  notificationAlert = React.useRef();  
  const history = useHistory();

  const [categories, setCategories] = useState([]);
  // const pId = !window.sessionStorage.getItem('pId') || window.sessionStorage.getItem('pId') == -1 ? 0 : window.sessionStorage.getItem('pId');

  const onSelectCategory = (e, category) => {
    if(aTimeout)
      clearTimeout(aTimeout);
    window.sessionStorage.setItem('p_aphorism', JSON.stringify(category));
    window.sessionStorage.setItem('catg_deep', 1);
    history.push('../coach/apList');
  }

  const addCategory = (e) => {
    window.sessionStorage.setItem('newFlag', 1);
    // window.sessionStorage.setItem('pId', 0);
    history.push('../coach/aphorismsEdit');
  }
  const onEditSelectedItem = (e, item) => {
    aTimeout = setTimeout(function(){
      window.sessionStorage.setItem('s_aphorism', JSON.stringify(item));
      // window.sessionStorage.setItem('pId', 0);
      window.sessionStorage.setItem('newFlag', 0);
      history.push('../coach/aphorismsEdit');
    }, 1000);
  }
  const onEditSelectedItem1 = (e, item) => {
    if(window.mobileCheck())
      return;
    onEditSelectedItem(e, item);
  }
  useEffect(() => {
     
    if(session === null){
      window.location = '/';
    }

    axios.get(URL_API+"getAphorismsAPI", {
      params: {
        sel: session['id'], 
        p_id:0,        
        f:1
      }
    })
    .then(function (response) {    
      if(response.data != ""){
        setCategories(response.data);
      }
    }); 
  }, []);
  
  return (
    <>
      <div className="content px-0 pb-0">
        <NotificationAlert ref={notificationAlert} />
        <Card className="mb-0">
            <div className="text-right d-flex align-items-center pr-2 justify-content-end" style={{height:'50px'}}>
              <span className="p-2" onClick={(event) => addCategory(event)}><i className="fas fa-plus add_s_items"></i></span>
            </div>     
            <CardBody className="px-1 coach-aph">
              <div className="col-12">
              {
                categories?.map((tmp, index) =>                                
                  <div key={index} className="col-12 border-bottom py-2" onClick={(e) => onSelectCategory(e, tmp)} onTouchStart = {(event) => onEditSelectedItem(event, tmp)} onMouseDown = {(event) => onEditSelectedItem1(event, tmp)}>                                         
                    {tmp.content}
                  </div>                    
              )}
              </div>
            </CardBody>
          </Card>
      </div>
    </>
  );
}

export default Aphorisms;
